// Ajaxblocks

import appState from '../util/appState';
import Sortable from 'sortablejs';
import notie from 'notie';
import formToJSON from './formToJSON';
import Mousetrap from 'mousetrap';
let $document;
let mousedown = false;

const ajaxBlocks = {

  init() {
    $document = $(document);

    // Only init handlers if any ajaxblocks on page
    if ($('.ajaxblocks').length) {

      // Add item links
      $document.on('click', '.addItem[data-type]', ajaxBlocks.addClick);

      // Detect mousedown clicks
      $document.on('mousedown', 'textarea', () => {
        mousedown = true;
      });

      // Edit item links
      $document.on('click', '.ajaxblock a.edit', ajaxBlocks.editClick);
      $document.on('dblclick', '.ajaxblocks', e => {
        if (e.target.parentElement.hasAttribute('data-edit-on-click')) {
          ajaxBlocks.editClick(e);
        }
      });
      $document.on('dblclick', '.actions', e => {
        // If double-clicking on open space in ajaxblocks actions div at bottom, trigger Add Item click
        if (e.target.hasAttribute('data-add-on-click')) {
          $(e.target).find('.addItem').trigger('click', e);
        }
      });

      // Textarea select if text is "New Item"
      $document.on('focus', 'input,textarea', ajaxBlocks.checkInputValueOnFocus);

      // Delete item links
      $document.on('click', '.ajaxblock a.delete', ajaxBlocks.deleteClick);

      // Key handler inside ajaxblock form (esc, enter, cmd+enter)
      $document.on('keydown', '.ajaxblock form', ajaxBlocks.keyHandler);

      // Save item links
      $document.on('click', '.ajaxblock form .button.primary', ajaxBlocks.saveClick);

      // Cancel item links
      $document.on('click', '.ajaxblock form .cancel', ajaxBlocks.cancelClick);

      ajaxBlocks.initSortables();

    }
  }, // end _init()

  /**
   * Focusing input, check for augmented behavior
   */
  checkInputValueOnFocus(e) {
    // Select text if value is "New Item" or [data-select-on-focus]
    if (!mousedown && e.target.value == 'New Item') {
      setTimeout(() => {
        e.target.select();
      }, 5);
    }
    // If tabbing into textarea, move cursor to end
    else if (e.target.tagName === 'TEXTAREA') {
      // Check if mouse was clicked
      if (!mousedown && e.target.setSelectionRange) {
        setTimeout(() => { this.setSelectionRange(this.value.length, this.value.length); }, 5);
      }
    }
    mousedown = false;
  },

  /**
   * Sortable ajaxblocks
   */
  initSortables() {
    $('.ajaxblocks.sortable:not(.inited)').each(function() {
      let ajaxblocks = this;
      this.classList.add('inited');
      let type = ajaxblocks.getAttribute('data-type');
      let category_id = ajaxblocks.getAttribute('data-category-id');

      // If category_id is set (e.g. links), change action
      let action = (category_id) ? 'save-ajaxblock-category-order' : 'save-ajaxblock-order';

      let sortable = new Sortable(ajaxblocks, {
        handle: '.drag-handle',
        onUpdate: function() {
          $.getJSON('/inc/ajaxBlocks.php', {
            'action': action,
            'type': type,
            'category_id': category_id,
            'ids': sortable.toArray()
          }).done(response => {
            if (response.status !== 1) {
              ajaxBlocks.handleError(response.msg);
            }
          });
        }
      });
    });
   },

  /**
   * Save clicked inside ajaxblock edit form
   */
  saveClick(e) {
    e.preventDefault();
    let form = $(e.target).parents('form')[0];
    ajaxBlocks.saveForm(form);
  },

  /**
   * Cancel link clicked inside ajaxblock edit form
   */
  cancelClick(e, ajaxBlockEl) {
    e.preventDefault();
    if (typeof ajaxBlockEl === 'undefined') {
      ajaxBlockEl = $(e.target).parents('.ajaxblock')[0];
    }
    ajaxBlocks.cancelEdit(ajaxBlockEl);
  },

  /**
   * Edit link clicked inside ajaxblock .editbox
   */
  editClick(e, ajaxBlockEl) {
    e.preventDefault();
    if (typeof ajaxBlockEl === 'undefined') {
      ajaxBlockEl = $(e.target).parents('.ajaxblock')[0];
    }
    if (ajaxBlockEl.querySelectorAll('form').length === 0) {
      ajaxBlocks.editItem(ajaxBlockEl);
    }
  },

  /**
   * Add Item button clicked
   */
  addClick(e, el) {
    e.preventDefault();
    if (typeof el === 'undefined') {
      el = e.target;
    }
    let where = el.getAttribute('data-inject-where') || 'bottom';
    ajaxBlocks.addItem(el.getAttribute('data-type'), el.getAttribute('data-parent-id'), where);
  },

  /**
   * Delete link clicked inside ajaxblock .editbox
   */
  deleteClick(e) {
    e.preventDefault();
    if (confirm('Are you sure?')) {
      ajaxBlocks.deleteItem($(e.target).parents('.ajaxblock')[0]);
    }
  },

  /**
   * Handles keydown on ajaxblock forms
   */
  keyHandler(e) {
    var ajaxblockEl = $(e.target).parents('.ajaxblock')[0];

    // Esc cancels form
    if (e.keyCode == 27) {
      // Check there aren't any open datepickers
      if (document.querySelectorAll('.pika-single:not(.is-hidden)').length === 0) {
        e.preventDefault();
        ajaxBlocks.cancelEdit(ajaxblockEl);
      }
    }

    // Hitting enter on input field?
    if (e.target.tagName === 'INPUT' && e.keyCode == 13)  {
      // If not a datepicker input, save form
      if (!e.target.classList.contains('date-picker')) {
        e.preventDefault();
        ajaxBlocks.saveForm(ajaxblockEl.querySelector('form'));
      } else {
        // Otherwise focus next input (> label > input)
        e.target.nextElementSibling.nextElementSibling.focus();
      }
    }

    // Hitting meta+enter on textarea field?
    if (e.keyCode == 13 && e.metaKey)  {
      e.preventDefault();
      // Save form
      ajaxBlocks.saveForm(ajaxblockEl.querySelector('form'));
    }
  },

  /**
   * Cancel an ajaxblock edit form
   */
  cancelEdit(ajaxblock) {
    let form = ajaxblock.querySelector('form');
    // Check if this is a newly added item (data-mode="add")
    if (form.getAttribute('data-mode') == 'add') {
      // If new item, just delete it
      ajaxBlocks.deleteItem(ajaxblock);
    } else {
      // Cancelling editing an existing item, just empty form and unhide ajaxblock
      ajaxblock.querySelector('.form').innerHTML = '';
      ajaxblock.querySelector('.meat').classList.remove('hidden');
      ajaxblock.classList.remove('form-open');
      // Focus after cancelling
      setTimeout(function(){ ajaxblock.focus(); }, 50);
    }
  },

  /**
   * Adds a new ajaxblock
   *
   * Creates db item, populates in $type/list template, appends to DOM
   * and then triggers Edit to open form
   */
  addItem(type, parentId, where) {
    let ajaxblocksEl = parentId ? $('.ajaxblocks[data-type="' + type + '"][data-parent-id="' + parentId + '"]')[0] : $('.ajaxblocks[data-type="' + type + '"]')[0];
    // let parentId = ajaxblocksEl.getAttribute('data-parent-id') || '';
    $.getJSON('/inc/ajaxBlocks.php', {
      'type': type,
      'parent_id': parentId,
      'action': 'add-ajaxblock',
      'where': where
    }).done(response => {
      if (response.status === 1) {
        // Extract first div inside ajaxblock
        let tmpDiv = document.createElement('div');
        tmpDiv.innerHTML = response.html;
        let newBlock = tmpDiv.querySelector('div');
        if (where == 'top') {
          ajaxblocksEl.prepend(newBlock);
        } else {
          ajaxblocksEl.append(newBlock);
        }
        ajaxBlocks.checkNewItem(newBlock);
        ajaxBlocks.editItem(newBlock, 'add');
      } else {
        ajaxBlocks.handleError(response.msg);
      }
    });
  },

  /**
   * Loads a form to edit an ajaxblock
   */
  editItem(ajaxblock, mode) {
    if (typeof mode === 'undefined') {
      mode = 'edit';
    }
    let type = ajaxblock.getAttribute('data-type');
    let meat = ajaxblock.querySelector('.meat')
    let form = ajaxblock.querySelector('.form')
    meat.classList.add('working');

    appState.requestInProgress = true;
    $.getJSON('/inc/ajaxBlocks.php', {
      'type': type,
      'id': ajaxblock.getAttribute('data-id'),
      'mode': mode,
      'action': 'edit-ajaxblock'
    }).done(response => {
      appState.requestInProgress = false;
      if (response.status === 1) {
        // Add modal
        ajaxblock.setAttribute('role', 'dialog');
        document.body.classList.add('dialog-open');

        ajaxblock.classList.add('form-open');
        meat.classList.add('hidden');
        meat.classList.remove('working');
        form.innerHTML = response.html;
        // Give first input focus (and select content) if not datepicker
        let firstInput = ajaxblock.querySelector('select,textarea,input[type=text]');
        if (firstInput && !firstInput.classList.contains('date-picker')) {
          firstInput.focus();
        }

        Mousetrap(form).bind(['return'], e => {
          let focused = document.activeElement;
          if (focused.classList.contains('cancel')) {
            ajaxBlocks.cancelClick(e, $(focused).parents('.ajaxblock')[0]);
          }
        });

      } else {
        ajaxBlocks.handleError(response.msg);
      }
    });
  },

  handleError(msg) {
    // Show error
    notie.alert({ type: 'error', text: msg });

    // If not logged in, redirect to login page
    if (msg.match('not logged in')) {
      setTimeout(function() {
        location.href = '/user/login?redir=' + encodeURIComponent(location.href);
      }, 1500);
    }
  },

  /**
   * Deletes an ajaxblock
   */
  deleteItem(ajaxblock) {
    let type = ajaxblock.getAttribute('data-type');
    let id = ajaxblock.getAttribute('data-id');

    appState.requestInProgress = true;
    $.getJSON('/inc/ajaxBlocks.php', {
      'type': type,
      'id': id,
      'action': 'delete-ajaxblock'
    }).done(response => {
      appState.requestInProgress = false;
      if (response.status === 1) {
        // todo: show notie with "undo" option, hide element, settimeout to delete in 3-5 seconds, "undo" button clears timeout
        ajaxblock.remove();

        // Dispatch custom event
        let event = new CustomEvent('delete-ajaxblock', { detail: { type: type, id: id } });
        window.dispatchEvent(event);

      } else {
        ajaxBlocks.handleError(response.msg);
      }

      // Remove modal
      document.body.classList.remove('dialog-open');
    });
  },

  /**
   * Saves an ajaxblock form
   */
  saveForm(form) {
    // Handle submission
    var ajaxblockEl = $(form).parents('.ajaxblock')[0];
    let type = ajaxblockEl.getAttribute('data-type');
    let id = ajaxblockEl.getAttribute('data-id');
    // Check for required fields
    if (ajaxBlocks.checkForm(form)) {
      ajaxblockEl.classList.add('working');
      appState.requestInProgress = true;
      $.post('/inc/ajaxBlocks.php', {
        'type': type,
        'id': id,
        'data': formToJSON(form),
        'action': 'save-ajaxblock'
      }).done(response => {
        ajaxblockEl.classList.remove('form-open');
        appState.requestInProgress = false;
        if (response.status === 1) {

          // Extract first div inside ajaxblock
          let tmpDiv = document.createElement('div');
          tmpDiv.innerHTML = response.html;
          let newBlock = tmpDiv.querySelector('div');
          ajaxblockEl.innerHTML = newBlock.innerHTML;
          ajaxBlocks.checkNewItem(ajaxblockEl);
          ajaxblockEl.classList.remove('working');
          setTimeout(function(){ ajaxblockEl.focus(); }, 50);

          // Dispatch custom event
          let event = new CustomEvent('save-ajaxblock', { detail: { type: type, id: id } });
          window.dispatchEvent(event);

        } else {
          ajaxBlocks.handleError(response.msg);
        }
        // Remove modal
        ajaxblockEl.setAttribute('role', '');
        document.body.classList.remove('dialog-open');
      });
    }
  },

  /**
   * Basic js form validation
   */
  checkForm(form) {
    let errors = '',
      focusAfter;

    form.querySelectorAll('[required]').forEach((field) => {
      if (field.value.trim() === '') {
        focusAfter = focusAfter || field;
        let fieldName = field.name.replace(/[\-_]+/g,' ').trim();
        errors += 'Please enter a value for "' + fieldName + '"\n';
      }
    });

    if (errors) {
      notie.alert({ type: 'error', text: errors });
      focusAfter.focus();
      return false;
    }

    return true;

  },

  /**
   * New item was added or updated
   *
   * Run various checks like adding to sortable, updating order totals
   */
  checkNewItem(ajaxblock) {
    let type = ajaxblock.getAttribute('data-type');

    // if (type == 'cart') {}

    // Check for any messages returned, e.g. data-msg="foo"
    // _checkDataMsg();
  },

  /**
   * Check for any messages returned from server-side and show in modal
   *
   * Elements can be populated with data-msg="Something went wrong"
   * after saving or adding an item
   */
  checkDataMsg() {
    // $('[data-msg]').each(function(el){
    //   let modal_html = el.getAttribute('data-msg');
    //   if (modal_html != '') {
    //     new SimpleModal({
    //       hideFooter: true,
    //     }).show({
    //       title: 'Please note!',
    //       contents: modal_html
    //     });
    //     // Clear out msg
    //     el.set('data-msg','');
    //   }
    // });
  },

};

export default ajaxBlocks
